import gql from 'graphql-tag';

export const USER_REWIND_PERSON_FRAGMENT = gql`
  fragment UserRewindPersonFragment on Person {
    __typename
    id
    firstName
    lastName
    picture {
      path
    }
  }
`;

export const USER_REWIND_MOVIE_FRAGMENT = gql`
  fragment UserRewindMovieFragment on Movie {
    __typename
    id
    internalId
    title
    poster {
      __typename
      path
    }
    credits(department: DIRECTION, first: 3) {
      __typename
      edges {
        __typename
        node {
          __typename
          person {
            __typename
            firstName
            lastName
          }
          position {
            __typename
            name
          }
        }
      }
    }
    stats {
      wantToSeeCount
    }
  }
`;

export const USER_REWIND_SERIES_FRAGMENT = gql`
  fragment UserRewindSeriesFragment on Series {
    __typename
    id
    internalId
    title
    poster {
      __typename
      path
    }
    credits(department: DIRECTION, first: 3) {
      __typename
      edges {
        __typename
        node {
          __typename
          person {
            __typename
            firstName
            lastName
          }
          position {
            __typename
            name
          }
        }
      }
    }
  }
`;

export const USER_REWIND_ENTITY_FRAGMENT = gql`
  fragment UserRewindEntityFragment on Node {
    ...UserRewindMovieFragment
    ...UserRewindSeriesFragment
    ...UserRewindPersonFragment
  }
  ${USER_REWIND_MOVIE_FRAGMENT}
  ${USER_REWIND_SERIES_FRAGMENT}
  ${USER_REWIND_PERSON_FRAGMENT}
`;

export const USER_REWIND_SCREEN_FRAGMENT = gql`
  fragment UserRewindScreenFragment on RewindScreen {
    __typename
    name
    entities {
      __typename
      identifier
      entities {
        ...UserRewindEntityFragment
      }
    }
    data
  }
  ${USER_REWIND_ENTITY_FRAGMENT}
`;

export const USER_REWIND_FRAGMENT = gql`
  fragment UserRewindFragment on UserSocialInformation {
    __typename
    rewind {
      __typename
      screens {
        ...UserRewindScreenFragment
      }
    }
  }
  ${USER_REWIND_SCREEN_FRAGMENT}
`;

export const USER_REWIND_ME_FRAGMENT = gql`
  fragment UserRewindMeFragment on User {
    creationDate
    isClub300Member
    mainAvatar
    nickname
    stats {
      total_reviews
      total_ratings
      total_subscribers
    }
  }
`;
